import clsx from 'clsx'
import type { ComponentPropsWithoutRef } from 'react'
import { themeClasses } from '../shared/themeClasses'

type DescriptionListProps = ComponentPropsWithoutRef<'dl'>
type DescriptionTermProps = ComponentPropsWithoutRef<'dt'>
type DescriptionDetailsProps = ComponentPropsWithoutRef<'dd'>

export function DescriptionList({ className, ...props }: DescriptionListProps) {
  return <dl {...props} className={clsx(className, 'grid grid-cols-1 text-base/6 sm:grid-cols-[min(50%,--spacing(80))_auto] sm:text-sm/6')} />
}

export function DescriptionTerm({ className, ...props }: DescriptionTermProps) {
  return <dt {...props} className={clsx(className, 'col-start-1 border-t pt-3 first:border-none sm:border-t sm:py-3', themeClasses.dividerBorderSoft, themeClasses.textMuted)} />
}

export function DescriptionDetails({ className, ...props }: DescriptionDetailsProps) {
  return <dd {...props} className={clsx(className, 'pt-1 pb-3 sm:border-t sm:py-3 sm:nth-2:border-none', themeClasses.textPrimary, themeClasses.dividerBorderSoft)} />
}
